import { makeStyles } from "tss-react/mui";
import { constants } from "../../constants";
import { TPromptEntryVariant } from "./IPromptEntry";

interface IStyles {
    variant: TPromptEntryVariant;
}
export const useStyles = makeStyles<IStyles>()((theme, { variant }) => ({
    root: {
        display: "flex",
        width: "100%",
        maxWidth: constants.dimensions.maxWidth,
        height: variant === "end-page" ? "630px" : "98px",
        flexDirection: "column",
        userSelect: "none",
        backgroundColor:
            variant === "end-page" ? "transparent" : constants.color.black,
        position: "relative",
    },

    cardContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        bottom: 0,
        left: 0,
        gap: "22px",
    },

    entryPoint: {
        width: "100%",
        maxWidth: "1208px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignSelf: "center",
    },

    eyebrow: {
        fontFamily: "Gotham book",
        fontWeight: 410,
        fontSize: "12px",
        lineHeight: "20px",
        letterSpacing: "1.5px",
        color: constants.color.white,
        textTransform: "uppercase",
        marginTop: "19.5px",
    },

    input: {
        gridColumn: "3 / 20",
        gridRow: "2",
        "& .caption": {
            color: constants.color.white,
            textTransform: "uppercase",
            letterSpacing: "2px",
            fontWeight: constants.fontWeight.plus,
            fontSize: "16px",
            marginBottom: "24px",
        },

        "&.MuiInputBase-root": {
            fontFamily: '"Galaxie Copernicus"',
            width: "100%",
            fontSize: "24px",
            fontWeight: 525,
            lineHeight: "32px",
            "& input": {
                width: "100%",
                color: constants.color.white,
                "&::placeholder": {
                    color: constants.color.white,
                    fontStyle: "italic",
                },
            },
        },
        "&.collapsed": {
            gridRow: "1",
            paddingTop: "24px",
            "& .caption": {
                display: "none",
            },
            "& .input-box": {
                "& .MuiInputBase-root": {
                    width: "100%",
                    fontSize: "26px",
                    lineHeight: "34px",
                },
            },
        },
    },
}));
